import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Analytics } from '@vercel/analytics/react';
import './index.css';
import './styles/public-site.css';
import './axiosConfig';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { redactAnalyticsEvent } from './utils/analyticsRedaction';

const SentryErrorFallback = () => (
  <main role="alert">
    <h1>Something went wrong</h1>
    <p>Please refresh the page and try again.</p>
  </main>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
    {/* Mounted here rather than in App: Jest 27 can't resolve this package's
        `/react` subpath, and many tests render App. */}
    <Analytics beforeSend={redactAnalyticsEvent} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
